import { type SvgComponentType } from "@newsela/angelou";

import {
  ADMIN_TOOLS_MENU_ADMIN_CONSOLE_DASHBOARD_ITEM,
  ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM,
  ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM,
  ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM,
  STAFF_INTERNAL_TOOLS_ITEMS,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { PopoutMenuSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection";
import useHasFeature from "@/features/useHasFeature";
import { PopoutSectionItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItem";
import { USER_FEATURE_TO_CRUD_A_CONTENT_PROMOTION_CONFIGURATION } from "@/components/ContentPromotions/constants";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { HomeMenuSubItemPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuSubItemPopout";

const HomeMenuAdminPopout = ({ onClickBack }: IHomeMenuAdminPopout) => {
  const ADMIN_CONSOLE_MENU_ITEM = ADMIN_TOOLS_MENU_ADMIN_CONSOLE_DASHBOARD_ITEM;

  const {
    isStaff,
    canViewAdminConsole,
    canAccessImplementationGuide,
    isAuthorizedPrincipal,
    isAuthorizedDistrictAdmin,
  } = useGetUserProperties();

  const userSeniorRoleIsPrincipal =
    isAuthorizedPrincipal && !isAuthorizedDistrictAdmin;

  const [canCrudAContentPromotionConfiguration] = useHasFeature(
    USER_FEATURE_TO_CRUD_A_CONTENT_PROMOTION_CONFIGURATION,
  );

  return (
    <HomeMenuSubItemPopout
      dataTestId="home-admin-popout"
      onClickBack={onClickBack}
    >
      {!isStaff && (
        <PopoutMenuSection width="275px" title="Admin tools">
          {canViewAdminConsole && (
            <PopoutSectionItem
              badge="New"
              key={ADMIN_CONSOLE_MENU_ITEM.dataQASelector}
              href={ADMIN_CONSOLE_MENU_ITEM.href}
              title={ADMIN_CONSOLE_MENU_ITEM.title}
              SvgComponent={
                ADMIN_CONSOLE_MENU_ITEM.SvgComponent as SvgComponentType
              }
              dataQASelector={ADMIN_CONSOLE_MENU_ITEM.dataQASelector}
            />
          )}

          {canAccessImplementationGuide && (
            <PopoutSectionItem
              key={ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.dataQASelector}
              href={ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.href}
              title={ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.title}
              SvgComponent={
                ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.SvgComponent as SvgComponentType
              }
              dataQASelector={
                ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.dataQASelector
              }
            />
          )}

          {canCrudAContentPromotionConfiguration && (
            <PopoutSectionItem
              badge={userSeniorRoleIsPrincipal ? "New" : undefined}
              key={ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.dataQASelector}
              href={ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.href}
              title={ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.title}
              SvgComponent={
                ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.SvgComponent as SvgComponentType
              }
              dataQASelector={
                ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.dataQASelector
              }
            />
          )}

          <PopoutSectionItem
            key={ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.dataQASelector}
            href={ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.href}
            title={ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.title}
            SvgComponent={
              ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.SvgComponent as SvgComponentType
            }
            dataQASelector={
              ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.dataQASelector
            }
          />
        </PopoutMenuSection>
      )}

      {isStaff && (
        <PopoutMenuSection title="Internal staff tools">
          {STAFF_INTERNAL_TOOLS_ITEMS.map(
            ({ title, href, SvgComponent, dataQASelector }) => (
              <PopoutSectionItem
                key={dataQASelector}
                href={href}
                title={title}
                SvgComponent={SvgComponent}
                dataQASelector={dataQASelector}
              />
            ),
          )}
        </PopoutMenuSection>
      )}
    </HomeMenuSubItemPopout>
  );
};

interface IHomeMenuAdminPopout {
  onClickBack: () => void;
}

HomeMenuAdminPopout.displayName = "HomeMenuClassesPopout";
export { HomeMenuAdminPopout };
